import { RootState } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { IElementsById } from "core-integration/src/store/elements/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import React from "react";
import { connect } from "react-redux";
import Shirt from "./Shirt";

interface IPropsFromState {
  elementsById: IElementsById;
  rules: IRules | null;
  teamsById: ITeamsById;
}
interface IOwnProps {
  elementId: number;
  hasShadow?: boolean;
  sizes: string;
}

type Props = IPropsFromState & IOwnProps;

export const getElementShirtPath = (
  elementType: number,
  teamCode: number,
  shirtMode: string,
) => {
  const suffix = elementType === 1 ? `_${elementType}` : "";
  return `/dist/img/shirts/${shirtMode}/shirt_${teamCode}${suffix}`;
};

const ElementShirt: React.FC<Props> = ({
  elementId,
  elementsById,
  hasShadow,
  rules,
  sizes,
  teamsById,
}) => {
  const element = elementsById[elementId];
  const team = teamsById[element.team];

  let shirtMode = "standard";
  if (rules && rules.ui_use_special_shirts) {
    if (rules.ui_special_shirt_exclusions.indexOf(element.code) === -1) {
      shirtMode = "special";
    }
  }

  return (
    <Shirt
      hasShadow={hasShadow}
      path={getElementShirtPath(element.element_type, team.code, shirtMode)}
      sizes={sizes}
      team={team}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  elementsById: getElementsById(state),
  teamsById: getTeamsById(state),
  rules: getRules(state),
});

export default connect(mapStateToProps)(ElementShirt);
